import React, { useEffect } from "react";

import {
  IgListItemButton,
  IgRadio,
  IgSelect,
  IgTypography,
} from "@intelligems/ig-theme";
import { VisitorType } from "@intelligems/ig-types";
import { Grid, MenuItem } from "@mui/material";
import { visitorTypeList } from "@src/components/AudienceFilters/utils";

interface VisitorProps {
  onClick: (arg1: any, arg2?: any) => void;
  visitorType?: VisitorType | null;
  isView?: boolean;
}

export const Visitor = ({ visitorType, onClick, isView }: VisitorProps) => {
  const selectedCard = (selectedVisitorType: string | undefined): boolean => {
    return visitorType === selectedVisitorType;
  };

  return (
    <Grid item container spacing={2} direction={"row"}>
      {visitorTypeList.map((visitorType) => (
        <Grid item xs={4} key={visitorType.key}>
          <IgListItemButton
            buttonFontWeight={400}
            disabled={isView}
            igVariant={"primary"}
            label={visitorType.label}
            onClick={() => {
              onClick(visitorType.key, "visitorType");
            }}
            selected={selectedCard(visitorType.key)}
          />
        </Grid>
      ))}
    </Grid>
  );
};

interface VisitorSelectProps {
  onChange: (value: any, changeKey: "key" | "filter" | "value") => void;
  visitorType: VisitorType;
}

// make a visitor select dropdown just like DeviceSelect
export const VisitorSelect = ({
  onChange,
  visitorType,
}: VisitorSelectProps) => {
  // handle when type switched and value not compatible
  useEffect(() => {
    if (!visitorTypeList.find((visitor) => visitor.key === visitorType))
      onChange(visitorTypeList[1].key, "value");
  }, []);

  return (
    <Grid item>
      <IgSelect
        variant={"outlined"}
        key={`visitor-type`}
        value={visitorType || visitorTypeList[1].key}
        onChange={(e) => {
          onChange(e.target.value, "value");
        }}
      >
        {visitorTypeList
          .filter((visitorType) => !!visitorType.key)
          .map((visitorType) => (
            <MenuItem key={visitorType.key} value={visitorType.key}>
              {visitorType.label}
            </MenuItem>
          ))}
      </IgSelect>
    </Grid>
  );
};

interface VisitorRadioProps {
  onClick: (arg1: any, arg2?: any) => void;
  visitorType?: VisitorType | null;
  isView?: boolean;
}

export const VisitorRadio = ({
  onClick,
  visitorType,
  isView,
}: VisitorRadioProps) => {
  const selectedRadio = (selectedVisitorType: string | undefined): boolean => {
    if (!visitorType) return false;
    return visitorType === selectedVisitorType;
  };

  return (
    <Grid container direction={"column"}>
      {visitorTypeList.map((visitorType, index: number) => (
        <Grid
          item
          key={visitorType.key}
          sx={{ "& :hover": { cursor: "pointer" } }}
          onClick={() => onClick(visitorType.key, "visitorType")}
        >
          <IgRadio
            disabled={isView}
            label={visitorType.label}
            checked={selectedRadio(visitorType.key)}
          />
        </Grid>
      ))}
    </Grid>
  );
};
